import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { router } from './routes';
import { RegistrationProvider } from './context/RegistrationContext';
import { WregDevProvider } from './components/webreg/dev/WregDevContext';
import { ApiErrorProvider } from './context/ApiErrorContext';
import ErrorBoundary from './components/ErrorBoundary';
import { chatBotManager } from './services/chatBotManager';

const AppContent = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    chatBotManager.init(
      new Map([
        ['data-ft-embed-script-language', i18n.language],
      ]),
    );
  }, [i18n.language]);

  return (
    <WregDevProvider>
      <RouterProvider router={router} />
    </WregDevProvider>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <RegistrationProvider>
        <ApiErrorProvider>
          <AppContent />
        </ApiErrorProvider>
      </RegistrationProvider>
    </ErrorBoundary>
  );
};

export { App };
